<template>
	<div class="com-right-content text-white">
		<div>
			<BlockBox title="应急救护登记表" enTitle="Registration Form" height="325">
				<template #content>
					<div style="height:200px;padding:0 0;box-sizing: border-box">
						<dv-scroll-board :config="yjjhdjDataConfig" style="width:100%;height:230px" />
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="应急救护培训在线考试" enTitle="Online Exam" height="326">
				<template #content>
					<!-- <div class="tabBox">
						<div class="menuBox flex align-center justify-center">
							<div class="menuItem " :class="index==xffsDataTabIndex?'checked':''"
								v-for="(item,index) in xffsDataTab" :key="index" @click="xffsDataTabClck(index)">
								{{ item.name }}
							</div>
						</div>
					</div> -->
					<div style="height:200px;padding:0 0;box-sizing: border-box">
						<dv-scroll-board :config="xffsDataConfig" style="width:100%;height:230px" />
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="设备活跃度" enTitle="Equipment Usage" height="306">
				<template #content>
					<div style="padding:20px 15px 0 15px;box-sizing: border-box">
						<div id="chartsbhydtj" style="height:225px;"></div>
					</div>
				</template>
			</BlockBox>
		</div>
	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox'
	import {
		rightData
	} from "@/api/api";
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		mixins: [echartMixins],
		data() {
			return {
				item: {},
				colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],

				// mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
				//开始***************
				timerRight: null,
				yjjhdjDataConfig: {},
				xffsDataTabIndex: 0,
				xffsDataConfig: {

				},


			}
		},
		mounted() {

			this.$nextTick(() => {
				this.drawCddjtj()
				this.initGetData()
			})


		},
		beforeDestroy() {
			clearTimeout(this.timerRight);
		},
		methods: {
			initGetData() {
				let _self = this
				rightData().then(res => {
					let redCrossRegisterList = []
					let questionList = []
					res.data.redCrossRegisterList.forEach((item) => {
						redCrossRegisterList.push([item.address, item.date, item.personNum])
					})
					res.data.questionList.forEach((item, index) => {
						questionList.push(['<span class="text-color-blue text-bold">TOP' + (index + 1) +
							'</span>', item.name, item.value
						])
					})
					_self.yjjhdjDataConfig = {
						header: ['单位', '时间', '数量'],
						indexHeader: "序号",
						data: redCrossRegisterList,
						index: true,
						oddRowBGC: 'rgba(5,38,117,0.5)',
						evenRowBGC: 'rgba(9,79,200,0.1)',
						columnWidth: [70, 240, 120, 80]
					}
					_self.xffsDataConfig = {
						header: ['排名', '姓名', '总得分'],
						data: questionList,
						oddRowBGC: 'rgba(5,38,117,0.5)',
						evenRowBGC: 'rgba(9,79,200,0.1)',
						columnWidth: [200, 200, 200]
					}
				})
			},



			drawCddjtj(hstjData) {
				this.chart = this.$echarts.init(document.getElementById("chartsbhydtj"));
				console.log(hstjData)
				let dateList = [];
				let dateValue = [];
				// hstjData.forEach(obj => {
				//     dateList.push(obj.site_name);
				//     dateValue.push(obj.weight);
				// })

				dateList = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
				dateValue = [6, 10, 5, 7, 20, 18, 10, 10, 5, 7, 20, 25]
				let option = {
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top: 20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',

						axisTick: {
							show: false,
						},
						data: dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.1)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [{
						name: '数量/人数',
						type: 'line',
						barWidth: 9,
						data: dateValue,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: {
										//数值样式
										color: 'white',
										fontSize: 12,
									},
								},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
							}
						},

					}, ]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			},





		}
	}
</script>

<style lang="scss">
	.com-right-content {
		min-height: 500px;
		padding: 14px 15px 15px 15px;
		box-sizing: border-box;

		.wzdjItem {
			width: 100%;
			height: 35px;
			line-height: 21px;
			padding: 11px 0;
			cursor: pointer;
		}

		.wzdjItem:hover {
			color: #006AF6;
		}

		.wzdjItem .leftNum {
			width: 21px;
			height: 21px;
			border-radius: 2px;
			background: #006AF6;
			line-height: 21px;
			text-align: center;
		}

		.wzdjItem .leftNum.one {
			background: -webkit-linear-gradient(top, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
		}

		.wzdjItem .leftNum.two {
			background: -webkit-linear-gradient(top, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Safari 5.1 - 6.0 */
			background: -o-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Opera 11.1 - 12.0 */
			background: -moz-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
			/* Firefox 3.6 - 15 */
			background: linear-gradient(to bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
		}

		.shtjBox {
			height: 250px;

			& .swiper {
				height: 250px;
			}
		}
	}


	.hnzbLable {
		margin-top: 10px;
	}

	.hnzbLable .itemLable {
		line-height: 1;
		border: 1px solid;
		color: #2196f3;
		font-size: 12px;
		padding: 5px 7px;
		border-radius: 1px;
	}

	.hnzbLable .itemLable+.itemLable {
		margin-left: 7px;
	}

	.hnzbLable .itemLable.checked {
		background: #006AF6;
		color: #FFFFFF;
		border-color: #006AF6;
	}

	//调整区域****************
	.padding-top-10 {
		padding-top: 10px;
	}

	.videoBox {
		width: 100%;
		height: 205px;
		border-radius: 10rpx;
		overflow: hidden;

		iframe {
			width: 100%;
			height: 240px;
		}
	}

	.text-white {
		color: #FFFFFF;
	}

	.enTitle {
		padding-left: 3px;
		font-size: 13px;
		border-left: 2px solid #FFFFFF;
		margin-left: 7px;
		font-weight: lighter;
	}

	.base-titleBox-flex {
		padding-top: 9px;
		line-height: 1
	}


	.text-green {
		color: #15ff15;
	}

	.midTitleBox {
		font-size: 15px;
		font-weight: bold;
		color: #FFFFFF;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.base-font-16 {
		font-size: 16px;
	}

	.text-bold {
		font-weight: bold;
	}



	.el-input__inner {
		background: rgba(8, 69, 120, 0.2);
		border-color: #006AF6;
		color: #00a2d5;
	}

	.el-input__prefix,
	.el-input__suffix {
		color: #00a2d5;
	}
</style>